import "./whatMakesRyseDifferent.css";

const DIFFERENT_ITEMS = [
  {
    id: 1,
    title: "1. Non-Linear Mathematics, Not Gaussian Assumptions",
    body: [
      `Ryse estimates the true statistical distributions observed in market data, pair-by-pair, constructing joint cumulative distribution functions to derive real dependency structures. This approach produces correlation estimates that reflect actual behavior — a critical advancement over legacy models that assume everything is normally distributed.`,
      `The result: more accurate portfolio hedging, more realistic risk estimates, and better analytics for complex assets such as hedge funds, private credit, private equity, and real estate.`,
    ],
  },
  {
    id: 2,
    title: "2. Autonomous AI Agents With Real Analytical Tools",
    body: [
      `Each Agent in our platform has a defined personality and a set of specialized tools — enabling it to compute linear analytics, non-linear metrics, Monte Carlo engines, cointegration, VaR, news search, reporting, and more.`,
      `Users interact conversationally, while the agents interpret, compute, and explain results with full mathematical rigor.`,
    ],
  },
  {
    id: 3,
    title: "3. Cloud-Accelerated Parallel Computing",
    body: [
      `Ryse is engineered for performance.`,
      `Our suite of parallel cloud engines allows even lightweight devices to run institution-grade analytics in real time by leveraging distributed computation. This delivers the speed, scalability, and efficiency required by modern investment teams and research environments.`,
    ],
  },
];

export default function WhatMakesRyseDifferentSection() {
  return (
    <section className="ryse-different p-40-20">
      <h2 className="ryse-different__title">What Makes Ryse Different</h2>

      <div className="ryse-different__grid">
        {DIFFERENT_ITEMS.map((item) => (
          <article key={item.id} className="ryse-different__card">
            <h3 className="ryse-different__card-title">{item.title}</h3>

            {item.body.map((paragraph, idx) => (
              <p key={idx} className="ryse-different__card-text">
                {paragraph}
              </p>
            ))}
          </article>
        ))}
      </div>
    </section>
  );
}
